<template>
  <div>
    <div style="font-family:Arial; font-size:20px; font-weight:bold; width:800px; text-align:center; margin-top:30px; margin-bottom:30px;">ORUFLOW Entegre Rapor</div>
    <div class="clear"><svg id="svg1" class="integratedReport"></svg></div>
    <div class="clear"><span class="head">Dolum fazı grafiği:</span><svg id="svg2" class="integratedReport"></svg></div>
    <div style="page-break-before: always;"> </div>
    <div class="clear">
      <span class="head">İşeme fazı grafiği:</span><svg id="svg3" class="integratedReport"></svg>

  <div style="padding:15px; padding-left:60px; width:700px;">
    <table style="float: left;" class="examInfoIntegrated">
      <tbody>
        <tr>
          <th>Max. akış hızı</th>
          <td>:</td>
          <td>{{ exam_detail.max_speed }} ml/s</td>
        </tr>
        <tr>
          <th>Max hıza ulaş.</th>
          <td>:</td>
          <td>{{ exam_detail.max_speed_time }} sn</td>
        </tr>
        <tr>
          <th>İşenen hacim</th>
          <td>:</td>
          <td>{{ exam_detail.total_volume }} ml</td>
        </tr>
      </tbody>
    </table>
    <table style="float:right;" class="examInfoIntegrated">
      <tbody>
        <tr>
          <th>İşeme süresi</th>
          <td>:</td>
          <td>{{ exam_detail.duration }} sn</td>
        </tr>
        <tr>
          <th>Ort. akış hızı</th>
          <td>:</td>
          <td>{{ exam_detail.average_speed }} ml/sn</td>
        </tr>
      </tbody>
    </table>
    <div style="clear:both; padding-top:15px;"><!--<span style="text-decoration:underline; font-weight:bold;">Doktor görüşü:</span> {{ exam_detail.comment }}--></div>
  </div>

    </div>
  </div>
</template>

<script>
import d3 from 'd3'
import IntegratedChart from '../IntegratedChart'
import Settings from '../settings'

export default {
  data () {
    return { exam_detail: {} }
  },
  mounted () {
    var examId = this.$route.params.examId

    var vm = this

    /* this.$http.get('http://' + Settings.host + ':6161/' + 'reportIntegrated.json')
      .then((response) => { // success
        console.dir(response)
      }) */

    this.$http.get('http://' + Settings.host + ':6161/' + 'api/exam_detail/' + examId)
      .then((response) => { // success
        var w = response.data.weight_array.split(' ').map(function (item) { return parseInt(item, 10) })
        var s = response.data.speed_array.split(' ').map(function (item) { return parseFloat(item) })

        var weight = []
        var speed = []

        for (var i = 0; i < w.length; i++) {
          weight.push(w[i])
          speed.push(s[i])
        }

        vm.exam_detail = response.data

        vm.exam_detail.max_speed = vm.exam_detail.max_speed.toFixed(2)
        vm.exam_detail.average_speed = vm.exam_detail.average_speed.toFixed(2)
        vm.exam_detail.total_volume = vm.exam_detail.total_volume.toFixed(2)

        console.log(vm.exam_detail)

        var data2Url = 'http://localhost:6161/reportIntegrated.json'

        d3.json(data2Url, function (dataObj) {
          var newDomain = Array(weight.length)

          for (var i = 0; i < newDomain.length; i++) {
            newDomain[i] = i * 1000
          }

          console.log(dataObj)

          var maxNewDomain = d3.max(newDomain)

          var startMerging = false
          var urinationStart = 0
          var v = 0

          // var newWeight = d3.scale.linear().domain(newDomain).range(weight)
          var newSpeed = d3.scale.linear().domain(newDomain).range(speed)

          console.log('Available max Qura sec:', maxNewDomain)

          for (var f = 0; f < dataObj['Sample#'].length; f++) {
            if (startMerging === false && dataObj['İşaretler'][f] === 171) { startMerging = true; urinationStart = f }

            if (startMerging) {
              if (v > maxNewDomain) { dataObj['Qura'][f] = 0 } else { dataObj['Qura'][f] = newSpeed(v) }
              v += 100
            }
          }

          console.log('Merged till', v, 'ms')

          dataObj.Interval = (1000 / dataObj.Samplerate)

          dataObj.Sample = dataObj['Sample#'].map(function (s) { return new Date(s * dataObj.Interval) })

          var svg1 = new IntegratedChart(document.querySelector('#svg1'), dataObj, 0, dataObj['Sample#'].length - 1) // d3.extent(dataObj.Sample))
          svg1.draw()

          console.log('min', d3.max(dataObj.Sample))

          var svg2 = new IntegratedChart(document.querySelector('#svg2'), dataObj, 0, urinationStart) // [d3.min(dataObj.Sample), dataObj.Sample[urinationStart]])
          svg2.draw()

          var svg3 = new IntegratedChart(document.querySelector('#svg3'), dataObj, urinationStart, dataObj['Sample#'].length - 1)
          svg3.draw()
        })

        vm.$nextTick(function () {
          // if (this.$route.query.print) { window.print() }
        })
      }, (response) => { // error
        console.log(response)
      })
  }
}

</script>

<style>

.examInfoIntegrated {
  font-family: Arial;
  line-height: 20px;
  border-collapse: separate;
  border-spacing: 2px;
  font-size: 14px;
}

.examInfoIntegrated th {
  text-align: left;
  width:100px;
  font-weight: bold;
}

.integratedReport .axis {
  /*font: 10px sans-serif;*/
  font-size: 10px;
  font-family: "Arial"
}

.integratedReport .axis--y text {
  transform-origin: 100px;
}

/*
.integratedReport .axis--x line {
  stroke: #000;
  opacity: 0.4;
  stroke-dasharray: 0, 14, 1, 0;
  stroke-width:2;
  stroke-linecap:square;
}
*/
.head { font-family: Arial; font-weight: bold; margin-top: 60px; margin-bottom: 8px; display: block; }

.integratedReport .domain {
  stroke: #000;
  stroke-width:1.0;
  shape-rendering: crispEdges; /* this fixed, "blurred 1 px line" issue*/

  fill:none;
}

.integratedReport { background-color:#fafafa; }

@media print {

}
</style>



// WEBPACK FOOTER //
// src/components/IntegratedReport.vue